import {
  TEACHERS_PAYMENTS_MODAL_ACTION_TYPE,
} from "../actions-type";

const initialState = {
  teachersPaymentModalData: {
    fullName: "",
    courses: "",
    email: "",
    password: "",
    salary: "",
    createdAt: "",
    sector: "",
    birthday: "",
    fin: "",
    seria: "",
    phone: "",
    workExperience: "",
    maritalStatus: "",
    disability: "",
    healthStatus: "",
  },
  teachersPaymentOpenModal: false,
  teachersModalLoading: false,
  openConfirmModal: false,
};

export const teachersPaymentModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.GET_TEACHERS_PAYMENTS_MODAL:
      return {
        ...state,
        teachersPaymentModalData: action.payload.data,
        teachersPaymentOpenModal: action.payload.openModal,
        openConfirmModal: action.payload.confirmModal,
      };
    // case TEACHERS_MODAL_ACTION_TYPE.TEACHER_OPEN_MODAL:
    case TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.TEACHER_PAYMENT_OPEN_MODAL:
      return {
        ...state,
        teachersPaymentOpenModal: action.payload,
      };
    // case TEACHERS_MODAL_ACTION_TYPE.TEACHER_MODAL_LOADING:
    case TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.TEACHER_PAYMENT_MODAL_LOADING:
      return {
        ...state,
        teachersModalLoading: action.payload,
      };

    default:
      return state;
  }
};
